import { useRef, useEffect, useState } from 'react';
import PalmerSectionLabel from './PalmerSectionLabel';

const clients = [
  {
    img: 'https://framerusercontent.com/images/rmeBLxZhEpvUaEnrIirzHJQynwc.png',
    logo: 'https://framerusercontent.com/images/np97j2F8KUZ2HLiullJ6eZCAlsQ.png',
    name: 'Modular Eight',
  },
  {
    img: 'https://framerusercontent.com/images/yw1GCZxhNp9c0ifxjP3zVlEc.png',
    logo: 'https://framerusercontent.com/images/f0y1IAXP7xxPZoecHyx9XHFdiHA.png',
    name: 'Studio Orbit',
  },
  {
    img: 'https://framerusercontent.com/images/KOQjQrydrJvVSvzcz2fLyVMiuBc.png',
    logo: 'https://framerusercontent.com/images/6IX9srHugK666NPKQJythMbMME.png',
    name: 'Haus of Signal',
  },
  {
    img: 'https://framerusercontent.com/images/wA52DtSvQDx894hqLZv4ezfKfz8.png',
    logo: 'https://framerusercontent.com/images/liDp6RqOmZpoiyriU2da9i9ZRNM.png',
    name: 'Clavmen Studio',
  },
  {
    img: 'https://framerusercontent.com/images/IhwR33YbJAKylGnbmoCW4maBHI.png',
    logo: 'https://framerusercontent.com/images/6IX9srHugK666NPKQJythMbMME.png',
    name: 'Novaform Labs',
  },
];

export default function PalmerClients() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => {
      setActiveIndex((i) => (i + 1) % clients.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [visible]);

  return (
    <section ref={sectionRef} className="bg-black py-20">
      <PalmerSectionLabel
        left1="© Brand Partners パートナー"
        left2="(WDX® — 08)"
        right="Creative Teams"
      />

      <div className="px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Left: stacked cards */}
          <div className="lg:col-span-7">
            <div className="relative" style={{ height: 400 }}>
              {clients.map((client, i) => (
                <div
                  key={client.name}
                  className="absolute inset-0 transition-all duration-700 overflow-hidden"
                  style={{
                    opacity: i === activeIndex ? 1 : 0,
                    transform: i === activeIndex ? 'scale(1)' : 'scale(0.97)',
                    zIndex: i === activeIndex ? 10 : 0,
                  }}
                >
                  <img
                    src={client.img}
                    alt={client.name}
                    className="w-full h-full object-cover object-top"
                  />
                  {/* Logo overlay */}
                  <div className="absolute bottom-4 left-4 bg-black/60 px-3 py-2">
                    <img src={client.logo} alt={client.name} className="h-6 object-contain opacity-80" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: client list */}
          <div className="lg:col-span-5 flex flex-col justify-center">
            {clients.map((client, i) => (
              <button
                key={client.name}
                className={`text-left border-t border-white/10 py-4 flex items-center justify-between transition-all duration-300 cursor-pointer ${i === activeIndex ? 'text-white' : 'text-white/30'}`}
                onClick={() => setActiveIndex(i)}
              >
                <span className="text-sm font-medium" style={{ fontFamily: "'DM Sans', sans-serif" }}>{client.name}</span>
                <span className="text-xs" style={{ fontFamily: "'DM Sans', sans-serif" }}>0{i + 1}</span>
              </button>
            ))}
            <div className="border-t border-white/10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
